import Client from "../client";
import ConfigurationRepository from "./configurationRepository";
import BuiltInRepositoryConfigurationResource from "../resources/builtInRepositoryConfigurationResource";

class BuiltInRepositoryConfigurationRepository extends ConfigurationRepository<BuiltInRepositoryConfigurationResource> {
    constructor(client: Client) {
        super("RepositoryConfiguration", client);
    }
}

export default BuiltInRepositoryConfigurationRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/builtInRepositoryConfigurationRepository.ts